var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.5101 16.204v-12.032l-2.6711-.034634.12882-1.8477 2.527-1.5753h2.8012v15.49m6.8516-7.7637c-8e-6-1.913-.13527-3.2591-.40569-4.0379-.26532-.78571-.71431-1.1786-1.347-1.1786-.63269 0-1.0842.39288-1.3547 1.1786-.2704.77888-.40563 2.1249-.40562 4.0379-8e-6 1.9335.13522 3.2965.40562 4.0891.27044.79259.722 1.1889 1.3547 1.1889.62761 0 1.0766-.39627 1.347-1.1889.27042-.79256.40568-2.1556.40569-4.0891m2.9466.03088c-1.5e-5 2.5348-.40818 4.4923-1.2246 5.8724-.81637 1.3733-1.9747 2.06-3.4748 2.06-1.5052 0-2.666-.68667-3.4824-2.06-.81638-1.3801-1.2245-3.3376-1.2245-5.8724 0-2.5417.40816-4.4991 1.2245-5.8724.81638-1.3801 1.9772-2.0702 3.4824-2.0702 1.5001 0 2.6584.69007 3.4748 2.0702.81639 1.3733 1.2246 3.3307 1.2246 5.8724"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.102250978b5515c041ca7c14139fa4d6.svg";
export { ForwardRef as ReactComponent };